export const appStyles = {
  width: "100%",
};
